import { isPublicShortId } from "@/lib/notebook/public/public-path";

/** Canonical public notebook path: `/p/{permanentId}`. */
export function publicNotebookPath(publicId: string): string {
  const id = publicId.trim();
  return `/p/${encodeURIComponent(id)}`;
}

/** Prefer permanent short id; fall back to stored slug for legacy rows. */
export function resolvePublicNotebookId(
  publicShortId: string | null | undefined,
  publicSlug: string | null | undefined,
): string | null {
  if (publicShortId?.trim()) return publicShortId.trim();
  const slug = publicSlug?.trim();
  if (!slug) return null;
  if (isPublicShortId(slug)) return slug;
  const dual = slug.match(/-([a-z0-9]{7})$/i);
  if (dual) return dual[1];
  return slug;
}

export function publicNotebookUrl(
  publicShortId: string | null | undefined,
  publicSlug: string | null | undefined,
  origin?: string,
): string | null {
  const id = resolvePublicNotebookId(publicShortId, publicSlug);
  if (!id) return null;
  const path = publicNotebookPath(id);
  if (!origin) return path;
  return `${origin.replace(/\/$/, "")}${path}`;
}
